
@if (vagaSelected()) {
  <div class="drawer-header border-bottom">
    <span class="title">Detalhes da vaga</span>
    <p-button (onClick)="closeModal()" icon="pi pi-times" [rounded]="true" [text]="true" severity="secondary" />
  </div>
  <div class="content-drawer p-4">
  
    <div class="basic-info">
      <div class="avatar">
        <p-avatar
          *ngIf="!imageError && empresaLogoUrl; else defaultLogo"
          [image]="empresaLogoUrl"
          shape="circle"
          size="xlarge"
          (onImageError)="imageError = true"
        />
        <ng-template #defaultLogo>
          <p-avatar
            [label]="getInitials(vagaDetail?.empresa?.nome || vagaDetail?.empresa)"
            [icon]="!(vagaDetail?.empresa?.nome || vagaDetail?.empresa) ? 'pi pi-building' : undefined"
            shape="circle"
            size="xlarge"
          />
        </ng-template>
      </div>
      <div class="details">
        <div class="name-area">
          <div class="left-area">
            <div class="title-header">
              <span class="name">{{ vagaDetail?.designacaoFuncao || 'Detalhes da Vaga' }}</span>
              <div class="info">
                <span><strong>{{ vagaDetail?.empresa?.nome || vagaDetail?.empresa || 'Empresa' }}</strong></span>
                <span>•</span>
                <span>{{ vagaDetail?.remuneracao ? (vagaDetail?.remuneracao + ' milhões / ano') : 'Remuneração a combinar' }}</span>
                <span *ngIf="vagaDetail?.estadoVaga && estadoVagaMap[vagaDetail?.estadoVaga]">•</span>
                <span *ngIf="vagaDetail?.estadoVaga && estadoVagaMap[vagaDetail?.estadoVaga]"> 
                  <p-tag [severity]="estadoVagaMap[vagaDetail.estadoVaga].severity"
                    [value]="'Vaga ' + estadoVagaMap[vagaDetail.estadoVaga].label" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between gap-3 mt-4">
      <div class="card-info w-50">
        <div class="icon">
          <i class="pi pi-map-marker"></i>
        </div>
        <div class="description">
          <span class="title">Localização</span>
          <span class="info mt-2"><strong>{{ vagaDetail?.localizacao || 'Não informada' }}</strong></span>
        </div>
      </div>
      <div class="card-info w-50">
        <div class="icon">
          <i class="pi pi-calendar"></i>
        </div>
        <div class="description">
          <span class="title">Data de encerramento</span>
          <span class="info mt-2">{{ vagaDetail?.dataEncerramento ? (vagaDetail?.dataEncerramento | date:'dd-MM-yyyy') : 'Não definida' }}</span>
        </div>
      </div>
    </div>

    <div class="avatar-info">
      <div class="flex justify-center">
        <p-avatar-group>
          <p-avatar icon="pi pi-user" shape="circle" />
          <p-avatar icon="pi pi-user" shape="circle" />
          <p-avatar icon="pi pi-user" shape="circle" />
          <p-avatar *ngIf="(candidatosCount ?? 0) > 3" [label]="'+' + ((candidatosCount ?? 0) - 3)" shape="circle" />
          <p>{{ candidatosCount ?? 0 }} {{ (candidatosCount === 1) ? 'Candidatura até o momento' : 'Candidaturas até o momento' }}</p>
        </p-avatar-group>
      </div>
    </div>

    <div class="about">
      <h3 class="title">Descrição da vaga</h3>
      <p>{{ vagaDetail?.descricao || 'Sem descrição informada.' }}</p>

      <h3 class="title">Público alvo</h3>
      <span *ngIf="vagaDetail?.pAlvo"><i class="pi pi-check"></i> Candidatos {{ vagaDetail.pAlvo }}</span>
      <span *ngIf="!vagaDetail?.pAlvo" class="text-muted">Não especificado</span>

      <h3 class="title">Requisitos necessários</h3>
      <ul>
        <li *ngIf="vagaDetail?.nivelHabilitacao"><i class="pi pi-check"></i> Habilitação mínima: {{ nivelHabilitacaoMap[vagaDetail.nivelHabilitacao] || vagaDetail.nivelHabilitacao }}</li>
        <li *ngIf="vagaDetail?.anoExperiencia"><i class="pi pi-check"></i> Experiência: {{ anoExperienciaMap[vagaDetail.anoExperiencia] || vagaDetail.anoExperiencia }}</li>
        <li *ngIf="vagaDetail?.regimeTrabalho"><i class="pi pi-check"></i> Regime de trabalho: {{ regimeTrabalhoMap[vagaDetail.regimeTrabalho] || vagaDetail.regimeTrabalho }}</li>
        <li *ngIf="vagaDetail?.tipoContrato"><i class="pi pi-check"></i> Tipo de contrato: {{ tipoContratoMap[vagaDetail.tipoContrato] || vagaDetail.tipoContrato }}</li>
        <li *ngIf="!vagaDetail?.nivelHabilitacao && !vagaDetail?.anoExperiencia && !vagaDetail?.regimeTrabalho && !vagaDetail?.tipoContrato" class="text-muted">
          Sem requisitos específicos registados.
        </li>
      </ul>

      <h3 class="title">Competências</h3>
      <div *ngIf="isLoadingCompetencias" class="d-flex align-items-center gap-2 py-2 text-muted">
        <i class="pi pi-spin pi-spinner"></i>
        <span>A carregar competências...</span>
      </div>

      <div class="d-flex flex-wrap gap-2 align-items-center" *ngIf="!isLoadingCompetencias && listaCompetencias && listaCompetencias.length > 0">
        @for (item of listaCompetencias; track trackById($index, item)) {
          <div class="comp-chip">
            <span class="label">{{ getCompetenciaNome(item) }}</span>
          </div>
        }
      </div>

      <p *ngIf="!isLoadingCompetencias && (!listaCompetencias || listaCompetencias.length === 0)" class="text-muted">
        Nenhuma competência associada a esta vaga.
      </p>

      <h3 class="title mt-4">Documentos Exigidos</h3>
      <div class="d-flex flex-wrap gap-2 align-items-center" *ngIf="documentosExigidos && documentosExigidos.length > 0">
        @for (doc of documentosExigidos; track $index) {
          <div class="comp-chip" style="background-color: var(--p-surface-100, #f1f5f9); border: 1px solid var(--p-surface-300, #cbd5e1); border-radius: 9999px; padding: 0.35rem 0.85rem; display: flex; align-items: center; gap: 0.5rem;">
            <i class="pi pi-file" style="color: var(--p-primary-500, #0284c7); font-size: 0.85rem;"></i>
            <span class="label" style="font-size: 0.85rem; font-weight: 500;">{{ doc.rotulo }}</span>
          </div>
        }
      </div>
      <p *ngIf="!documentosExigidos || documentosExigidos.length === 0" class="text-muted">
        Nenhum documento específico exigido para esta vaga.
      </p>
    </div>
  </div>
  
  <p-confirmdialog>
    <ng-template #message let-message>
      <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
        <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
        <p>{{ message.message }}</p>
      </div>
    </ng-template>
  </p-confirmdialog>
}

    